export default {
  // START:: SET APP THEME
  setAppTheme(state, payload) {
    state.glow_up_dashboard_theme = payload;
  },
  // END:: SET APP THEME
};
